import Input from "sap/m/Input";
import InputRenderer from "sap/m/InputRenderer";

/**
 * @namespace akademika.akamont.customControls
 */
export default class PasswordInput extends Input {
  private _isShown = false;
  private _domInput: HTMLInputElement | null = null;
  private _boundSync!: () => void;

  static renderer = InputRenderer;

  init(): void {
    super.init();
    this._boundSync = this.syncFromDom.bind(this);
    this.setShowValueHelp(true);
    this.setValueHelpIconSrc("sap-icon://show");
    this.attachValueHelpRequest(this.toggleReveal, this);
    this.setType("Password");
  }

  onBeforeRendering(oEvent: jQuery.Event): void {
    super.onBeforeRendering(oEvent);
    this.detachNativeListeners();
  }

  onAfterRendering(oEvent: jQuery.Event): void {
    super.onAfterRendering(oEvent);
    this._domInput = this.getFocusDomRef() as HTMLInputElement | null;
    if (this._domInput) {
      this._domInput.addEventListener("input", this._boundSync);
      this._domInput.addEventListener("change", this._boundSync);
    }

    // Firefox fills the field without firing events: check a few times after render.
    [100, 500, 1500].forEach((ms) => setTimeout(this._boundSync, ms));
  }

  exit(): void {
    this.detachNativeListeners();
    super.exit();
  }

  /** Push the browser's (possibly autofilled) value into the control → binding → model. */
  public syncFromDom(): void {
    if (this.isDestroyed()) {
      return;
    }
    const domValue = this._domInput?.value;
    if (domValue !== undefined && domValue !== this.getValue()) {
      this.setValue(domValue);
    }
  }

  private detachNativeListeners(): void {
    if (this._domInput) {
      this._domInput.removeEventListener("input", this._boundSync);
      this._domInput.removeEventListener("change", this._boundSync);
    }
    this._domInput = null;
  }

  toggleReveal(): void {
    this.syncFromDom();
    this._isShown = !this._isShown;
    this.setType(this._isShown ? "Text" : "Password");
    this.setValueHelpIconSrc(this._isShown ? "sap-icon://hide" : "sap-icon://show");
  }
}
